/**
 * @Author: v_jppjpeng
 * @Date: 2023-08-03 14:08:37
 * @Explain: 标签管理
 */

export default {
  // 模板变量 - 列表
  'LABEL.MANAGE.LIST.TITLE': '标签列表',
  'LABEL.MANAGE.CREATE.TAG': '创建标签',
  'LABEL.MANAGE.SEARCH.PLACEHOLDER': '请输入标签名称',
  'LABEL.MANAGE.NAME': '名称',

  'LABEL.MANAGE.COUNT.OF.CRATED.ON': '订阅用户数量',
  'LABEL.MANAGE.COUNT.OF.CRATED.ON.TIPS': '在{time}更新的订阅者数量',

  'LABEL.MANAGE.COUNT.OF.CRATED.ON.NEW': 'Email订阅用户',
  'LABEL.MANAGE.COUNT.OF.CRATED.ON.NEW.TIPS': '在{time}更新的email订阅用户数量',

  'LABEL.MANAGE.WHATSAPP.COUNT.OF.CRATED.ON': 'Whatsapp订阅用户',
  'LABEL.MANAGE.WHATSAPP.COUNT.OF.CRATED.ON.TIPS':
    '在{time}更新的WhatsApp订阅用户数量',
  'LABEL.MANAGE.ADD.DATE': '创建时间',
  'LABEL.MANAGE.SEND.CAMPAIGN': '发送活动',
  'LABEL.MANAGE.CREATE.BY': '创建人',
  'LABEL.MANAGE.PREDICTIVE.TAGS': '预测标签',
  'LABEL.MANAGE.PREDICTIVE.TAGS.DESC':
    '基于千万级历史数据，我们通过搭建数学模型对玩家行为进行预测，帮助你提前感知玩家行为数据并前置邮件活动进行干预',
  'LABEL.MANAGE.PREDICTIVE.TAGS.VIEW.MORE': '点击查看更多',

  // Predictive tags
  'LABEL.MANAGE.PREDICTIVE.TAGS.INFO':
    '以下数据为样本数据。该功能只有通过API同步游戏内数据后才可使用。你可以通过接入',
  'LABEL.MANAGE.PREDICTIVE.TAGS.SEND.COMPAIGN.DIS.INFO':
    '该功能只有通过API同步游戏内数据后才可使用。你可以通过接入',
  'LABEL.MANAGE.ENABLE.PREDICTION.FUNCTION': ' 开通预测功能',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.TITLE': '预流失',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.PREDICTIVE': '预测',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.DEMO': '样本数据',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.TERMS.TITLE': '标签解释',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.TERMS.TIPS':
    'Potential churn 根据玩家游戏内ID统计，在邮件活动时我们仅对有邮箱信息且订阅过的玩家进行递送',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.TERMS.DESC':
    '未来<span>{num}</span>天游戏大概率流失的玩家数量',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.CHARATERISTICS.TITLE': '人群特征',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.CHARATERISTICS.DESC':
    '对比历史情况，过去7天内活跃显著下降，在不干预的前提下即将流失的玩家。',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RECALL.TITLE': 'Expected recall',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION':
    '未来<span class="color-999">{num}</span>天预测玩家的留存情况',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.BUBBLE':
    '预测数据每天(UTC+00:00) 4:00AM更新',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.UPDATE.TIME':
    '<span class="color-999 font-size-16">更新时间:</span><span class="color-333 font-size-16">{time}</span>',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.LINE.Y': '人数',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.LINE.X': '天数',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.NUMBER': '预计留存人数',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.PERCENT': '预计留存占比',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.NUMBER.DESC':
    '原点对应人数为预测流失的总人数，随着时间推进玩家将逐渐流失',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.LINE.DATE': '天数',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.LINE.DATE.DESC':
    '原点对应天数为最新更新日期，预测周期为其后21天',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.SLOPE.TITLE': '曲线',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.SLOPE.DESC':
    '通过预测模型计算，该部分玩家大概率在未来21天内流失，你可以通过创建邮件活动提前召回玩家',

  // 规则说明
  'LABEL.MANAGE.LIST.DESC.TIPS1':
    '支持快速对标签创建活动，当您需要组合更复杂条件，可在',
  'LABEL.MANAGE.LIST.DESC.TIPS2': '分层列表',
  'LABEL.MANAGE.LIST.DESC.TIPS3': '中创建规则',

  // 模板变量 - 新增、编辑
  'LABEL.MANAGE.EDIT.TAG': '编辑标签',
  'LABEL.MANAGE.TAG.NAME': '标签名称',
  'LABEL.MANAGE.PLEASE.ENTER.TAG.NAME': '请输入标签名称',
  'LABEL.MANAGE.TAG.TIPS': '例如: KOL，影响者，或专业玩家',

  // 删除
  'LABEL.MANAGE.LIST.DELETE.MSG': '确定删除自定义标签？',
  'LABEL.MANAGE.LIST.DEL.TIPS':
    '删除 <b class="color-333">{name}</b> 后，标签信息不可恢复。',

  // 确认标签弹框
  'LABEL.MANAGE.TAG.BAND.TITLE': '确定绑定此标签？',
  'LABEL.MANAGE.TAG.BAND.CONTENT.1': '此标签为旅程的起点，联系人导入后会立即进入旅程。',
  'LABEL.MANAGE.TAG.BAND.CONTENT.2': '旅程名称：',
  'LABEL.MANAGE.TAG.BAND.CONTENT.3': '可在 ',
  'LABEL.MANAGE.TAG.BAND.CONTENT.4': ' 中查看。',
};
